var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 28.75L8.75 25L11.25 27.5L16.25 20L20 25M6.2475 8.75V1.25H24.375L28.75 5.625V28.75H25L6.2475 8.75ZM22.5 1.25V7.5H28.75L22.5 1.25ZM3.75 13.75H20V28.75H3.75V13.75ZM8.75 20C9.08152 20 9.39946 19.8683 9.63388 19.6339C9.8683 19.3995 10 19.0815 10 18.75C10 18.4185 9.8683 18.1005 9.63388 17.8661C9.39946 17.6317 9.08152 17.5 8.75 17.5C8.41848 17.5 8.10054 17.6317 7.86612 17.8661C7.6317 18.1005 7.5 18.4185 7.5 18.75C7.5 19.0815 7.6317 19.3995 7.86612 19.6339C8.10054 19.8683 8.41848 20 8.75 20Z",
    stroke: "#1A1515",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.5df8ed331c13b222934c7d9c9b146980.svg";
export { ForwardRef as ReactComponent };